import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectDateHeadersOption')(function selectDateHeadersOption(isDateHeadersEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isDateHeadersEnabled;
}));
//# sourceMappingURL=selectDateHeadersOption.js.map